module.exports = __webpack_public_path__ + "6c289bef297e0de31d26b3127337f325.svg";